import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { debounce } from '@ember/runloop';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';
import { MD_BREAKPOINT } from 'webapp/utils/common';

import FilterLineComponent from 'webapp/components/filter/line';

import type { AnyFilterSort } from 'webapp/models-custom/filter-sort/base';

interface Args {
	model: AnyFilterSort;
	theme?: string;
}

interface FilterLineProxyComponentInterface<T> {
	Args: T;
	Blocks: { default: [] }; // this is needed for yield
}

export default class FilterLineProxyComponent extends Component<
	FilterLineProxyComponentInterface<Args>
> {
	@service('navigation') declare navigationService: Service.Navigation;

	@tracked showJoinedFilterSwitchers = false;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.updateShowFilterButton();

		window.addEventListener('resize', this.updateShowFilterButtonDebounced);
	}

	@action
	updateShowFilterButtonDebounced(): void {
		debounce(this, this.updateShowFilterButton, 150);
	}

	private updateShowFilterButton(): void {
		const showJoinedFilterSwitchers = window.innerWidth < MD_BREAKPOINT;
		this.showJoinedFilterSwitchers = showJoinedFilterSwitchers;
	}

	override willDestroy() {
		super.willDestroy();
		window.removeEventListener('resize', this.updateShowFilterButtonDebounced);
	}
	<template>
		<div class="filter-line-proxy">
			<FilterLineComponent
				@model={{@model}}
				@theme={{@theme}}
				@showJoinedFilterSwitchers={{this.showJoinedFilterSwitchers}}
			>
				{{yield}}
			</FilterLineComponent>
		</div>
	</template>
}
